import moment from 'moment';

import { MARKET_INDEX_LABELS } from 'legacy/appstore/constants';

import { MarketIndexChartTooltipContent as theme } from 'legacy/css-modules';

const MarketIndexChartTooltipContent = ({ points, colors }) => {
  return (
    <div>
      {points && points.length && (
        <div className={theme.Date}>
          {moment(points[0].x).format('MMM DD, YYYY')}
        </div>
      )}
      {points.map((p, i) => {
        return (
          <div key={`tippoint-${i}`} className={theme.PointRow}>
            <div className={theme.Index}>{Math.round(p.y)}</div>
            <div className={theme.Market}>
              <div>Market Type:</div>
              <div
                className={theme.MarketType}
                style={{ color: colors[p.indexLevel] }}
              >
                {MARKET_INDEX_LABELS[p.indexLevel]}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MarketIndexChartTooltipContent;
